import { render, staticRenderFns } from "./ComponentPositionChart.vue?vue&type=template&id=1dbb86de"
import script from "./ComponentPositionChart.vue?vue&type=script&lang=js"
export * from "./ComponentPositionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports